import React from 'react';
import "./onboard-label-style.scss";
import {ReactComponent as PromotionIcon} from './images/promotion_code.svg';

const OnboardLabel = (props) => {

    const {text, icon} = props;

    return (
        <div className="onboard-label-root">
            {icon === 'promotion_code' && <PromotionIcon/>}
            <p>{text}</p>
        </div>
    )
};

export default OnboardLabel;
